import { objectKeys } from 'aem-libs-ts/src/utils/common/objectKeys'

type CreateQueryStringFromObjectConfig = {
  skipNullValues: boolean
}

const queryUtils = (() => {
  const addParamToQueryString = (queryString: string, name: string, value: string): string => {
    return queryString.concat(`&${name}=${value}`)
  }

  const createQueryStringFromObject = (
    queryObject: object,
    initValue?: string,
    config: CreateQueryStringFromObjectConfig = { skipNullValues: false }
  ): string => {
    const queryList: string[] = []
    objectKeys(queryObject)
      .filter((key: keyof typeof queryObject) => (config.skipNullValues && !queryObject[key] ? false : true))
      .forEach((key: keyof typeof queryObject) => {
        queryList.push(`${key}=${queryObject[key]}`)
      })

    if (queryList.length === 0) {
      return ''
    }

    const queryString = queryList.join('&')

    if (initValue) {
      return initValue + queryString
    }
    return queryString
  }

  return {
    createQueryStringFromObject,
    addParamToQueryString
  }
})()

export { queryUtils }
